import { render, staticRenderFns } from "./modalUploadVideo.vue?vue&type=template&id=5d16667e&scoped=true&"
import script from "./modalUploadVideo.vue?vue&type=script&lang=js&"
export * from "./modalUploadVideo.vue?vue&type=script&lang=js&"
import style0 from "./modalUploadVideo.vue?vue&type=style&index=0&id=5d16667e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d16667e",
  null
  
)

export default component.exports